package org.vreo.devicehub.features.settings.data.repository

import org.vreo.devicehub.features.core.domain.DataError
import org.vreo.devicehub.features.core.domain.EmptyResult
import org.vreo.devicehub.features.core.domain.Result
import org.vreo.devicehub.features.core.domain.device.device.anprDeviceSettings.AnprDeviceSettings
import org.vreo.devicehub.features.core.domain.device.device.networking.RemoteDeviceControl
import org.vreo.devicehub.features.core.domain.device.singleShootAutoFocus.SingleShotAutoFocusConfig
import org.vreo.devicehub.features.core.domain.device.videoCameraConfig.VideoConfig
import org.vreo.devicehub.features.core.domain.settingsRepository.SettingsRepository

/**
 * ANPR device settings control default repository. Allows to retrieve and update target device's main settings using
 * Tensor backend service
 *
 * @property deviceControl Provides access to device control methods
 */
class SettingsRepositoryDefault(
    val deviceControl: RemoteDeviceControl,
) : SettingsRepository {
    override suspend fun getDeviceSettings(
        token: String,
        deviceId: String
    ): Result<AnprDeviceSettings, DataError.Remote> {
        return deviceControl.getDeviceSettings(token, deviceId)
    }

    override suspend fun setDeviceSettings(
        token: String,
        deviceId: String,
        config: AnprDeviceSettings
    ): EmptyResult<DataError.Remote> {
        return deviceControl.setDeviceSettings(token, deviceId, config)
    }

    override suspend fun getVideoConfiguration(
        token: String,
        deviceId: String
    ): Result<VideoConfig, DataError.Remote> {
        return deviceControl.getVideoConfig(token, deviceId)
    }

    override suspend fun setVideoConfiguration(
        token: String,
        deviceId: String,
        config: VideoConfig
    ): EmptyResult<DataError.Remote> {
        return deviceControl.setVideoConfig(token, deviceId, config)
    }

    override suspend fun setSingleShotAutoFocus(
        token: String,
        deviceId: String,
        config: SingleShotAutoFocusConfig
    ): EmptyResult<DataError.Remote> {
        return deviceControl.setSingleShotAutoFocus(token, deviceId, config)
    }
}